import { Box } from '@mui/material';
import React from 'react';
import Community from './Community/Community';
import CoreBenifits from './CoreBenifits/CoreBenifits';
import DecentralizedFuture from './DecentralizedFuture/DecentralizedFuture';
import Ecosystem from './Ecosystem/Ecosystem';
import SmallDeviceEcosystem from './Ecosystem/SmallDeviceEcosystem';
import ExplainatoryVideo from './ExplainatoryVideo/ExplainatoryVideo';
import HomeBanner from './HomeBanner/HomeBanner';
import News from './News/News';
import NodeOperator from './NodeOperator/NodeOperator';
import Partnerships from './Partnerships/Partnerships';
import PublicLedgers from './PublicLedgers/PublicLedgers';
import Quantally from './Quantally/Quantally';
import QuestionAnswer from './QuestionAnswer/QuestionAnswer';
import TimeCounter from './TimeCounter/TimeCounter';
import SmallDeviceTimeLine from './TimeLine/SmallDeviceTimeLine';
import TimeLine from './TimeLine/TimeLine';
import Tokenomics from './Tokenomics/Tokenomics';
import WalkTraking from './WalkTraking/WalkTraking';

const Home = () => {
    return (
        <>
            <Box sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 } }}>
                <HomeBanner />
                <TimeCounter />
                <ExplainatoryVideo />
                <WalkTraking />
                <DecentralizedFuture />
                <PublicLedgers />
                <Quantally />
                <CoreBenifits />
                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    <Ecosystem />
                </Box>
                <Box sx={{ display: { sm: 'none' } }}>
                    <SmallDeviceEcosystem />
                </Box>
                <Tokenomics />
                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    <TimeLine />
                </Box>
                <Box sx={{ display: { sm: 'none' } }}>
                    <SmallDeviceTimeLine />
                </Box>
                <NodeOperator />
                <News />
                <Partnerships />
                <Community />
                <QuestionAnswer />
            </Box>
        </>
    );
};

export default Home;